var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"fill-height",attrs:{"elevation":"0"}},[_c('v-card-text',[_c('Announcement',{attrs:{"type":"home"}})],1)],1),_vm._v(" "),_c('br'),_c('v-card',{staticClass:"fill-height",attrs:{"elevation":"0"}},[_c('v-card-text',[_c('HomeCards')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }